import React from "react";

export function FormTitle({ children }) {
  return <h1 style={{ marginBottom: 10, fontSize: 24 }}>{children}</h1>;
}
